import en from "../../public/lang/en";
import fa from "../../public/lang/fa";

const getTrans = () => {
  const trans = fa;

  return trans;
};

export default getTrans;
